import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetMembershipApi } from 'src/Services/API';
import { AssetMembersDto } from 'src/Services/API/generated';
import { ApiError } from 'src/types/api-error.types';

const useFetchMembers = () => {
  const assetId = useCurrentAssetId();

  return useQuery<AssetMembersDto, AxiosError<ApiError>>({
    queryKey: ['fetch-members', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (await assetMembershipApi.membersControllerFindOne(assetId)).data;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchMembers;
